import { EXPRESS_DESIGNER_SEGMENT } from '../constants';
import type { ExpressDesignerCartArticle, ExpressDesignerCartStorage } from '../types';
import { readExpressDesignerSegment } from './readExpressDesignerSegment';

export function readExpressDesignerCartStorage(): ExpressDesignerCartStorage {
  return readExpressDesignerSegment<ExpressDesignerCartArticle>(EXPRESS_DESIGNER_SEGMENT.Cart);
}
